import styled from 'styled-components'

const HeroIlustrationStyled = styled.div`
  transform: scale(1.05);
  img {
    width: 100%;
    height: auto;
  }
  @media (min-width: 768px) {
    transform: scale(1.05) translate(-25px, 0px);
  }
  @media (min-width: 1024px) {
    transform: scale(1.05) translate(-25px, 0px);
    width: 650px;
  }
`

function HeroIlustration() {
  return (
    <HeroIlustrationStyled>
      <picture className="img">
        <source srcSet="/images/projects/landing/projects-landing-hero.webp" width="650" height="522.3" type="image/webp" />
        <source srcSet="/images/projects/landing/projects-landing-hero.png" width="650" height="522.3" type="image/png" />
        <img
          src="/images/projects/landing/projects-landing-hero.png"
          width="650"
          height="522.3"
          loading="lazy"
          alt="Crea tu portafolio basado en proyectos"
        />
      </picture>
    </HeroIlustrationStyled>
  )
}

export default HeroIlustration
